export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-4k-line',
      title: '4K超清画质',
      description: '蘑菇视频官网支持4K超清分辨率播放，搭配HDR技术，每一帧都细腻动人，带来影院级的视觉享受。',
    },
    {
      icon: 'ri-surround-sound-line',
      title: '杜比全景声',
      description: '精选内容支持杜比全景声，沉浸式音效让您仿佛置身电影场景之中，感受声音的每一处细节。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      description: '手机、平板、电脑、电视四端同步，蘑菇视频官网一个账号畅享所有设备，随时随地想看就看。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '正版内容',
      description: '蘑菇视频官网所有内容均为正版授权，严格的内容审核机制，为您提供安全可靠的观影环境。',
    },
    {
      icon: 'ri-download-cloud-2-line',
      title: '离线下载',
      description: '支持视频离线下载，无网络也能畅快追剧。蘑菇视频官网智能缓存技术，节省流量更省心。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '专属客服',
      description: '蘑菇视频官网提供7×24小时在线客服支持，会员更享专属客服通道，快速解决您的问题。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            为什么选择蘑菇视频
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            蘑菇视频官网以用户体验为核心，持续技术创新，为您打造最佳观影平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex gap-4 p-5 md:p-6 rounded-xl bg-background-50 hover:bg-background-100 transition-colors duration-200"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1.5">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}